import React from "react";
import {useSelector, useDispatch} from "react-redux";

import {
  clearFilterParameters,
  setCreatorFilterParameters,
} from "../../../../../../../redux/creators/creators.actions";
import {selectCreatorFilterParameters} from "../../../../../../../redux/creators/creators.selectors";
import {Form} from "react-bootstrap";

import {FaFilter} from "react-icons/fa";
import CreatorsListFilter from "../../../CreatorsListFilter";
import {GENDER_OPTIONS} from "../../../../../../../constants";
import ReelerTooltip from "../../../../../../../components/commons/ReelerTooltip/ReelerTooltip";
import CreatorLabels from "./CreatorLabels";
import ReelerButton from "../../../../../../../components/commons/ReelerButton";

export default function CreatorsFilter() {
  const filterParameters = useSelector(selectCreatorFilterParameters);
  const dispatch = useDispatch();

  const updateFilter = (key, value) => {
    dispatch(setCreatorFilterParameters({...filterParameters, [key]: value}));
  };

  const handleblacklistWhitelistFilter = (type) => {
    if (
      filterParameters &&
      filterParameters[type] !== null &&
      filterParameters[type] === true
    ) {
      updateFilter(type, null);
      return;
    }
    updateFilter(type, true);
  };

  const handleSelectGender = (e) => {
    const value = e.target.value;
    if (value === "showAll") {
      updateFilter("gender", null);
      return;
    }
    updateFilter("gender", value);
  };

  const handleOnChangeCreatorLabels = (labels) => {
    updateFilter("labels", labels);
  };

  return (
    <div
      className="d-flex flex-row pt-1"
      style={{background: "var(--reeler-grey)"}}
    >
      <div className="d-flex flex-col p-2 align-items-top">
        <FaFilter className="icon-color" />
        <div>:</div>
      </div>
      <div className="d-flex flex-column w-100">
        <div className="d-flex flex-row align-items-center mb-1">
          <div className="d-flex flex-row align-items-center me-3">
            <div className="me-1 w-100">Creator list:</div>
            <CreatorsListFilter />
          </div>
          <div className="d-flex flex-row align-items-center me-3">
            <div className="me-1 w-100">Gender:</div>
            <Form.Control
              as="select"
              size="sm"
              value={
                filterParameters?.gender ? filterParameters?.gender : "showAll"
              }
              onChange={handleSelectGender}
            >
              <option value="showAll">Show all</option>
              {GENDER_OPTIONS.map((option, index) => {
                return (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                );
              })}
            </Form.Control>
          </div>

          <div className="d-flex flex-column flex-md-row gap-2 gap-md-3 align-items-start align-items-md-center flex-wrap">
            <ReelerTooltip text="Greenlisted creators are prioritized for content import">
              <Form.Check // prettier-ignore
                type="checkbox"
                id="show-whitelisted-creators"
                label="Show only greenlisted creators"
                onChange={() => handleblacklistWhitelistFilter("whitelisted")}
                checked={filterParameters?.whitelisted}
                disabled={filterParameters?.blacklisted}
              />
            </ReelerTooltip>

            <ReelerTooltip text="Blacklisted creators are hidden, and their content is blocked from import (except via web forms)">
              <Form.Check // prettier-ignore
                type="checkbox"
                id="show-blacklisted-creators"
                label="Show only blacklisted creators"
                onChange={() => handleblacklistWhitelistFilter("blacklisted")}
                checked={filterParameters?.blacklisted}
                disabled={filterParameters?.whitelisted}
              />
            </ReelerTooltip>
          </div>
        </div>
        <div className="d-flex flex-row align-items-center mb-2 gap-2">
          <div
            className="d-flex flex-row align-items-center me-3"
            style={{width: "400px"}}
          >
            <CreatorLabels
              value={filterParameters?.labels || []}
              handleOnChange={handleOnChangeCreatorLabels}
            />
          </div>

          <ReelerButton
            styleClass="btn-link mx-2"
            text={<span>Clear all filters</span>}
            dispatch={() => {
              dispatch(clearFilterParameters());
            }}
          />
        </div>
      </div>
    </div>
  );
}
